export default {
  closeButtonBoxShadow: 'none',
  modalContentBackground: Styles.color.white,
  modalWrapperBackground: Styles.color.white,
};
